const ServicesProps = [
    {
        id: "1",
        imageSrc: "imgs/pencil-case.svg",
        name: "Adipisicing",
        content: "Labore velit culpa adipisci excepturi consequuntur itaque in nam molestias dolorem iste quod.",
    },
    {
        id: "2",
        imageSrc: "imgs/responsive.svg",
        name: "Sapiente",
        content: "Labore velit culpa adipisci excepturi consequuntur itaque in nam molestias dolorem iste quod.",
    },
    {
        id: "3",
        imageSrc: "imgs/toolbox.svg",
        name: "Placeat",
        content: "Labore velit culpa adipisci excepturi consequuntur itaque in nam molestias dolorem iste quod.",
    },
    {
        id: "4",
        imageSrc: "imgs/analytics.svg",
        name: "Iusto",
        content: "Labore velit culpa adipisci excepturi consequuntur itaque in nam molestias dolorem iste quod.",
    },
]

export default ServicesProps;